import isEmpty from "lodash/isEmpty"
import parseInt from "lodash/parseInt"
import isNumber from "lodash/isNumber"
import toPairs from "lodash/toPairs"
import forEach from "lodash/forEach"
import { useState, useEffect } from "react"
import { validatePhone } from "utils-lib/validation"
import useFeatureFlags from "hooks-lib/LaunchDarkly/useFeatureFlags"
import MaskedTextField from "component-lib/Base/components/MaskedTextField/MaskedTextField"
import { phonePattern } from "utils-lib/strings/maskPatterns"
import { defaultToSpace } from "utils-lib/strings"
import { getWindow } from "utils-lib/getWindow"

const ssrWindow = getWindow()

const PhoneInput = (
  {
    hasFocus = false,
    isRequired = false,
    onChange = () => {},
    customErrorMessage = ``,
    customErrorMessageWithIcon = null,
    hasError = false,
    handleKeyDown = () => {},
    label = ``,
    placeholder = ``,
    value = ``,
    onFocus = () => {},
    onBlur = () => {},
    disabled = false,
    fullWidth = false,
    testId = `PhoneInput`,
    InputProps = {},
    customClass = ``,
    formattedPhoneId = ``,
    style = {},
    error = false,
    required = false,
  },
  ...rest
) => {
  const [fieldHasFocus, setFieldHasFocus] = useState(false)

  const { LDFFReleaseBulkGuestFlowUiImprovement } = useFeatureFlags([
    "LDFFReleaseBulkGuestFlowUiImprovement",
  ])

  const formattedId = `phoneInputField-${label}`.replaceAll(/\s/g, "")
  const spreadProps = {
    style,
    required,
    error,
  }
  // fixes annoying consoler error "Warning: Invalid attribute name: `0`"
  forEach(toPairs(rest), ([key, value]) => {
    if (!isNumber(parseInt(key))) {
      spreadProps[key] = value
    }
  })

  useEffect(() => {
    if (hasFocus) {
      setFieldHasFocus(true)
    }
  }, [])

  useEffect(() => {
    if (fieldHasFocus) {
      ssrWindow.document.getElementById(`formattedId`).focus()
    }
  }, [fieldHasFocus])

  const doValidatePhone = (value) =>
    (!isRequired && isEmpty(value)) || validatePhone(value)

  const handleChange = (value) => {
    const isValid = doValidatePhone(value)
    onChange(value, isValid)
  }

  let className = `PhoneInput`
  if (!fieldHasFocus && hasError) {
    className = `PhoneInput input-error`
  }
  if (disabled) {
    className = `PhoneInput disabled-field`
  }

  let errorMessage = defaultToSpace(customErrorMessage)
  if (
    LDFFReleaseBulkGuestFlowUiImprovement &&
    !isEmpty(customErrorMessageWithIcon)
  ) {
    errorMessage = customErrorMessageWithIcon
  }

  return (
    <MaskedTextField
      data-testid={testId}
      variant="outlined"
      helperText={errorMessage}
      error={!isEmpty(customErrorMessage) || (!fieldHasFocus && hasError)}
      disabled={disabled}
      type="tel"
      name="tel"
      label={label || placeholder}
      onAccept={handleChange}
      onKeyDown={handleKeyDown}
      unmask={false}
      className={`${className} ${customClass}`}
      value={value}
      onFocus={onFocus}
      required={isRequired}
      fullWidth={fullWidth}
      onBlur={() => {
        onBlur(value, doValidatePhone(value))
      }}
      id={isEmpty(formattedPhoneId) ? formattedId : formattedPhoneId}
      mask={phonePattern}
      InputProps={InputProps}
      ariaLabel={label || placeholder}
      {...spreadProps}
    />
  )
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// PhoneInput.propTypes = {
//   hasError: PropTypes.bool,
//   hasFocus: PropTypes.bool,
//   isRequired: PropTypes.bool,
//   onChange: PropTypes.func.isRequired,
//   label: PropTypes.string,
//   placeholder: PropTypes.string,
//   value: PropTypes.string.isRequired,
//   onFocus: PropTypes.func,
//   onBlur: PropTypes.func,
//   className: PropTypes.string,
//   fullWidth: PropTypes.bool,
//   disabled: PropTypes.bool,
//   handleKeyDown: PropTypes.func,
//   customErrorMessage: PropTypes.string,
//   testId: PropTypes.string,
//   InputProps: PropTypes.object,
//   style: PropTypes.object,
//   error: PropTypes.bool,
//   helperText: PropTypes.string,
//   required: PropTypes.bool,
//   customClass: PropTypes.string,
//   formattedPhoneId: PropTypes.string,
// }

// Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// PhoneInput.defaultProps = {
//   hasError: false,
//   disabled: false,
//   hasFocus: false,
//   isRequired: false,
//   label: ``,
//   placeholder: ``,
//   className: ``,
//   fullWidth: false,
//   onFocus: () => {},
//   onBlur: () => {},
//   handleKeyDown: () => {},
//   customErrorMessage: ``,
//   testId: `PhoneInput`,
//   InputProps: {},
//   style: {},
//   error: false,
//   helperText: ``,
//   required: false,
//   customClass: "",
//   formattedPhoneId: "",
// }

export default PhoneInput
